import { render } from "./HomeMain.vue?vue&type=template&id=51713f3d&scoped=true"
import script from "./HomeMain.vue?vue&type=script&lang=js"
export * from "./HomeMain.vue?vue&type=script&lang=js"

import "./HomeMain.vue?vue&type=style&index=0&id=51713f3d&scoped=true&lang=css"

import exportComponent from "/home/runner/work/fomofinal/fomofinal/fomoapp/frontend3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51713f3d"]])

export default __exports__